module.exports = __webpack_public_path__ + "static/loda-web-c5938b70a2cc700f0b36060b61f0f3bd.jpg";